import {createFileRoute, useParams} from '@tanstack/react-router'
import React from "react";
import {useJwtUser} from "../../../../JWTAuthProvider.tsx";
import User_ProfileView from "../../../../user/User_ProfileView.tsx";
import User_PublicProfileView from "../../../../user/User_PublicProfileView.tsx";

export const Route = createFileRoute('/_app/profiles/$player_uid/')({
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false});
    const user = useJwtUser();

    if (params.player_uid === user?.uid) {
        return <User_ProfileView subpage={'profile'} />
    }

    return <User_PublicProfileView />
}
